import React from 'react'
import GatsbyConfig from '../../../gatsby-config.js'
import { getParamFromQueryString } from '../../utils/app-helpers'
import LineupCard from './lineup-card'

const { siteMetadata: config } = GatsbyConfig

export default class Lineup extends React.Component {
  render() {
    const { trip } = this.props
    let featured
    if (typeof window !== 'undefined') {
      featured = getParamFromQueryString('a', window.location.href)
    }
    const tripData = config.trips[trip]
    let lineupCards = []

    for (const index in tripData.lineup) {
      const person = tripData.lineup[index]
      if (person.comingSoon) {
        person.key = ''
        person.kind = ''
        person.name = 'Coming Soon'
        person.nameFirst = 'Coming'
        person.nameLast = 'Soon'
        if (person.book) person.book = 'gray-pinwheel'
      }
      const card = (
        <LineupCard key={`lineup-card-${index}`} trip={trip} person={person} />
      )
      if (featured && person.key.match(featured)) {
        lineupCards.unshift(card)
      } else {
        lineupCards.push(card)
      }
    }

    return (
      <div className={`lineup lineup-${lineupCards.length}-cards`}>
        <div className="cards">{lineupCards}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/lineup.js